<template>
  <div class="content">
    <div class="section">
      <h1 class="section-head">收款账户信息</h1>
      <div class="section-body">
        <p class="label-item">
          <label class="label-item-title">开户名:</label>
          <span class="label-item-text">{{receiveAccount.receiver}}</span>
        </p>
        <p class="label-item">
          <label class="label-item-title">开户行:</label>
          <span class="label-item-text">{{receiveAccount.bank}}</span>
        </p>
        <p class="label-item">
          <label class="label-item-title">账号(CNY):</label>
          <span class="label-item-text">{{receiveAccount.bankAccount}}</span>
        </p>
      </div>
    </div>
    <div class="section">
      <h1 class="section-head">付款账户信息</h1>
      <div class="section-body">
        <pay-account-item v-for="(item, i) in bankList" :key="`${item.id}_${i}`" :data="item" :index="i" :selected="item.bankAccount === bankAccount" @select="selectBank" @delete="deleteItem" @save="saveSuccess"></pay-account-item>
        <div class="add-account add-box" v-show="bankList.length < 5" @click="addBank"><i class="el-icon-plus"></i>添加账户信息</div>
      </div>
      <div class="section-body">
        <recharge-amount v-model="rechargeAmount"></recharge-amount>
      </div>
      <div class="section-body">
        <el-button type="primary" @click="recharge(2)">申请充值</el-button>
        <el-button type="primary" v-if="!receiveAccount.receiver.includes('南京')" v-auth="'xiaomi_online_pay'" @click="recharge(1)">在线充值</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {getReceiveAccount, getBankAccount, rechargeAction} from '../utils/api.js';
  import PayAccountItem from '../comps/pay-account-item.vue';
  import RechargeAmount from '../comps/recharge-amount.vue';
  export default {
    name: 'recharge',
    props: {
      type: String,
      id: String | Number
    },
    data() {
      return {
        receiveAccount: {
          receiver: '',
          bank: '',
          bankAccount: ''
        },
        rechargeAmount: '',
        bankList: [],
        bankAccount: ''
      }
    },
    computed: {
      agentParams() {
        const params = {};
        if (this.type == 'core') {
          params.type = this.type;
          params.id = this.id;
        }
        return params;
      }
    },
    components: {
      PayAccountItem,
      RechargeAmount
    },
    created() {
      this.getReceiveAccount();
      this.getBankAccount();
    },
    methods: {
      getCompanyName(type) {
        if (window.GLOBAL) {
          return type == 1 ? window.GLOBAL.userInfo && window.GLOBAL.userInfo.companyName : window.GLOBAL.currentAccount && window.GLOBAL.currentAccount.accountName;
        }
        return '';
      },
      async getReceiveAccount() {
        let result = await getReceiveAccount();
        if (result) {
          Object.assign(this.receiveAccount, result);
        }
      },
      async getBankAccount() {
        let result = await getBankAccount();
        if (result && result.length) {
          this.bankList = result;
          this.bankAccount = this.bankList[0].bankAccount;
        }
      },
      selectBank(bank) {
        this.bankAccount = bank.bankAccount;
      },
      addBank() {
        this.bankList.push({
          id: 0,
          companyName: this.getCompanyName(this.type == 'core' ? 4 : 2),
          bankAccount: ''
        });
      },
      deleteItem(index) {
        let isSelect = this.bankList[index].bankAccount === this.bankAccount;
        this.bankList.splice(index, 1);
        if (isSelect) {
          let i = index - 1 >= 0 ? index - 1 : 0;
          this.bankAccount = this.bankList.length ? this.bankList[i].bankAccount : '';
        }
      },
      saveSuccess(index, data) {
        Object.assign(this.bankList[index], data);
        this.bankAccount = data.bankAccount;
      },
      async recharge(type) {
        if (!this.bankAccount) {
          this.$alert('请选择付款账户!');
          return;
        }
        if (!this.rechargeAmount) {
          this.$alert('请输入金额!');
          return;
        }
        if (this.rechargeAmount >= 1000000000) {
          this.$alert('输入金额超出范围：0~999,999,999.99元!');
          return;
        }
        let params = {
          rechargeType: type,
          rechargeAmount: this.rechargeAmount,
          bankAccount: type == 2 ? this.bankAccount : '',
          companyName: this.getCompanyName(type)
        }
        let result = await rechargeAction(params);
        if (result && result.success) {
          if (type == 2) {
            const routeName = ['core', 'agent'].includes(this.type) ? 'rechargeRecord' : 'recharge-list';
            this.$router.push({name: routeName, params: this.agentParams});
          } else {
            window.open(result.result);
          }
        }
      }
    }
  }
</script>